import { useFlags } from "launchdarkly-react-client-sdk";

export const useSavedLessons = () => {
  const { savedLessons } = useFlags();

  return savedLessons;
};

export const useIntroHighlightedContent = () => {
  const { introHighlightedContentCard } = useFlags();

  return introHighlightedContentCard;
};
